export const GET_GLOSSARYTERMS = 'GET_GLOSSARYTERMS';
export const GET_TOOLTIPTERMS = 'GET_TOOLTIPTERMS';
